import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlugin2"><Path d="M4 3H11V7H4V3Z" fill="currentColor"/><Path d="M13 3H20V7H13V3Z" fill="currentColor"/><Path d="M2 8.5H22V20H2V8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin2;
